// extracted by mini-css-extract-plugin
module.exports = {"nav":"styles__nav___2yzcD","sidebar":"styles__sidebar___2Djq7"};